import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";

import { Button, Radio } from "antd";

const props = {
    signMethod: PropTypes.string.isRequired,
    onChange: PropTypes.func.isRequired,
    clearSignImageHandler: PropTypes.func.isRequired,
};

const SignMethodSection = ({ signMethod, onChange, clearSignImageHandler }) => {
    const { t } = useTranslation();

    return (
        <section className="sign-method-section mb-3">
            <Radio.Group value={signMethod} onChange={(e) => onChange(e.target.value)}>
                <Radio value="input">{t("input")}</Radio>
                <Radio value="draw">{t("draw")}</Radio>
            </Radio.Group>
            {signMethod !== "input" ? (
                <Button className="sign-clear-button" onClick={clearSignImageHandler}>
                    {t("clearSignature")}
                </Button>
            ) : null}
        </section>
    );
};

SignMethodSection.propTypes = props;

export default SignMethodSection;
